import { or } from '@tanstack/db'

type Condition = ReturnType<typeof or>

export function combineWithOr(conditions: Condition[]): Condition {
    if (conditions.length === 1) return conditions[0]
    return conditions.reduce((acc, cond) => or(acc, cond))
}
